/*
 * @Description: 报到总人数
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-06 15:39:51
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-08 16:59:46
 */
import React from 'react'
import styles from './styles.css'

export default class _CenterTop3 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { jrbdrs = 0 } = this.props.panelData
    return (
      <div className={styles.box_2_top_com}>
        <div className={styles.box_3_top}>
          <span className={styles.t_span1}>今日报到总人数</span>
          <span className={styles.t_span2}>{jrbdrs}</span>
          <div className={styles.t_p3}></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/_CenterTop3.js